import {SendMailType} from "../types/SendMailType";
import {ApiService} from "./ApiService";

export const SendMailService = {
  send: async (data: SendMailType) => {
    return await ApiService.post('/_/send_mail', { param: () => data });
  },
}
